import React from 'react'
import { Link } from 'react-router-dom'

const Copyright = () => {
  return (
 <div className='flex flex-col justify-center items-center bg-[#1050A2] p-1 text-white py-3'>
    <div className='pl-0 md:pl-4 mb-4 md:mb-0 mt-4 md:mt-0 md:flex md:justify-center md:items-center text-[12px]'>
      <Link to="/Policies/Privacypolicy" className='mr-2 md:mr-4'>
        Privacy Policy
      </Link>
      <span >|</span>
      <Link to="/websitepolicy" className='ml-2 md:ml-3 mr-2 md:mr-4'>
        Website Policies
      </Link>
      <span >|</span>
      <Link to="/Hyperlinkpolicy" className='ml-2 md:ml-3 mr-2 md:mr-4'>
        Hyperlinking Policies
      </Link>
      <span >|</span>
      <Link to="/Copyrightpolicy" className='ml-2 md:ml-3'>
        Copyright Policies
      </Link>
      <span className='ml-2'>|</span>
      <Link to="/components/Policies/content-contribution-moderation-approval-policy" className='ml-2 md:ml-3'>
        Content Contribution, Moderation & Approval policy
      </Link>
      <span className='ml-2'>|</span>
      <Link to="/components/Policies/content-review-policy" className='ml-2 md:ml-3'>
      Content Review policy (CRP)
      </Link>
      <span className='ml-2'>|</span>
      <Link to="/components/Policies/content-archival-policy" className='ml-2 md:ml-3'>
      Content Archival Policy (CAP)
      </Link>
      <span className='ml-2'>|</span>
      <Link to="/components/Policies/security-policy" className='ml-2 md:ml-3'>
      Security policy
      </Link>
    </div>
    <div className='flex  md:justify-end  md:items-center text-[12px]'>
      <Link to="https://ks-tech.in/" target="_blank" >
         Designed and Developed By- KRITASUTRA
      </Link>
    </div>
  </div>
   
  
  )
}

export default Copyright
